import React from 'react';
import { ClipboardCheckIcon, MapPinIcon, UsersIcon, WavesIcon } from 'lucide-react';
const items = [{
  label: 'Professional Pool Renovation',
  icon: WavesIcon
}, {
  label: 'Central Florida Service',
  icon: MapPinIcon
}, {
  label: 'Free Estimates',
  icon: ClipboardCheckIcon
}, {
  label: 'Reliable Local Team',
  icon: UsersIcon
}];
export function TrustBar() {
  return <section aria-label="Why homeowners choose Innova" className="border-t border-white/10 bg-navy" data-id="element-335" data-mp="1qxen22kykk2j">
      <ul className="mx-auto grid max-w-7xl grid-cols-2 lg:grid-cols-4 lg:px-8" data-id="element-336" data-mp="1uyq5no5f0518">
        {items.map(({
        label,
        icon: Icon
      }, i) => <li key={label} className={`flex items-center gap-3 border-white/10 px-5 py-6 lg:justify-center lg:py-8 ${i % 2 === 0 ? 'border-r' : ''} ${i < 2 ? 'border-b lg:border-b-0' : ''} ${i === 1 ? 'lg:border-r' : ''}`} data-id="element-337" data-mp="1gy5oewf5eh9u" data-mpi={i}>
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-accent/15 text-accent" data-id="element-338" data-mp="ajeq90hetaji">
              <Icon className="h-5 w-5" aria-hidden="true" data-id="element-339" data-mp="1ajosxzsona4f" />
            </span>
            <span className="text-sm font-semibold leading-snug text-white md:text-[15px]" data-id="element-340" data-mp="16i3lityx3o1m">{label}</span>
          </li>)}
      </ul>
    </section>;
}